// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".c-lazy-img{opacity:0;transition:all .5s}.c-lazy-img[data-loaded=true]{opacity:1}", "",{"version":3,"sources":["webpack://./src/scss/components/_lazy-load.scss"],"names":[],"mappings":"AAAA,YAAY,SAAS,CAAC,kBAAkB,CAAC,8BAA8B,SAAS","sourcesContent":[".c-lazy-img{opacity:0;transition:all .5s}.c-lazy-img[data-loaded=true]{opacity:1}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
